import { createContext } from "react"

const Three = createContext()

export default Three
